import React, { useState , useEffect} from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_LOANSTATUS } from "../Common/constant";
import Check from "@Images/NewUI/disbursed.gif";
import moment from "moment";

const LoanStatusLS = (props) => {

  const [loanStatusData, setLoanStatusData] = useState(props?.loanStatusData);
  let token = props?.user?.User?.token||localStorage.getItem("gpay_token");

  // console.log("ls Data", loanStatusData);
  // console.log("test history", props);
  return (
    <div className="main_div">
     
      {loanStatusData?.map((item, index) => {
        return (
          <div className="container">
            <div className="pb-4">
              <Heading
                headingText={HEADING_LOANSTATUS}
                backprops={"/loanhistory"}
                history={props.history}
              />
              <div className="wrapper-content">
                <div className="card-height-small w-100 mx-auto bg-white shadow-lg">
                  <div className="d-flex flex-column justify-content-between">
                    <div className="pt-0 pb-0">
                      <div className="check_div text-center pb-5">
                        <img src={Check} alt="success" />
                        <span>Status</span>
                        <span>
                          <strong>Paid</strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Applied on</span>
                        <span>
                          <strong>
                            {moment(item?.disbursal_date).format("DD-MM-YY")}
                          </strong>
                        </span>
                      </div>
                      <div className="flex space-between align-center">
                        <span>Disbursed on</span>
                        <span>
                          <strong>
                            {moment(item?.disbursal_date).format("DD-MM-YY")}
                          </strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-height-small w-100 mx-auto bg-white shadow-lg">
                  <div className="d-flex flex-column justify-content-between">
                    <div className="pt-0 pb-0">
                      <span className="loan-sub-h">Loan statement</span>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Sanctioned amount</span>
                        <span>
                          <strong>₹{item?.amount}</strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Interest (per day)</span>
                        <span>
                          <strong>0.10%</strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Tenure days</span>
                        <span>
                          <strong>{item?.tenure_days}</strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Processing fee</span>
                        <span>
                          <strong>
                            ₹{item?.fee_at_that_time?.current_processing_fee}
                          </strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Collection amount</span>
                        <span>
                          <strong>₹{item?.collection_amount}</strong>
                        </span>
                      </div>
                      <div className="wrapper_m flex space-between align-center">
                        <span>Collection date</span>
                        <span>
                          <strong>{item?.collection_date || "NA"}</strong>
                        </span>
                      </div>
                      {/* <div className="wrapper_m flex space-between align-center">
                        <span>Due Amount</span>
                        <span>
                          <strong>{item?.collection_date || "NA"}</strong>
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default LoanStatusLS;
